import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { LocalidadeState } from './state';

const defaultState: LocalidadeState = {
  localidades: [],
  mapaLocalidades: new Blob(),
};

export const localidadeModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
